var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.28688 5.99865H10.7117C11.1156 5.99865 11.3175 5.99865 11.411 5.91878C11.4922 5.84948 11.5352 5.74553 11.5269 5.63916C11.5172 5.51657 11.3744 5.37377 11.0888 5.08819L8.37641 2.37577C8.24441 2.24376 8.17841 2.17776 8.10228 2.15303C8.03535 2.13128 7.96321 2.13128 7.89628 2.15303C7.82021 2.17776 7.75421 2.24376 7.62215 2.37577L4.90975 5.08819C4.62417 5.37377 4.48138 5.51657 4.47173 5.63916C4.46336 5.74553 4.50642 5.84948 4.58755 5.91878C4.68106 5.99865 4.883 5.99865 5.28688 5.99865Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7117 10H5.28688C4.883 10 4.68106 10 4.58755 10.0799C4.50642 10.1492 4.46336 10.2531 4.47173 10.3595C4.48138 10.4821 4.62417 10.6249 4.90975 10.9105L7.62215 13.6229C7.75421 13.7549 7.82021 13.8209 7.89628 13.8457C7.96321 13.8674 8.03535 13.8674 8.10228 13.8457C8.17841 13.8209 8.24441 13.7549 8.37641 13.6229L11.0888 10.9105C11.3744 10.6249 11.5172 10.4821 11.5269 10.3595C11.5352 10.2531 11.4921 10.1492 11.411 10.0799C11.3175 10 11.1156 10 10.7117 10Z",
    stroke: "currentColor",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.4e54626bf072e6d939addff318202457.svg";
export { ForwardRef as ReactComponent };